import { BCADocumentFile, BCADocumentFileType, documentFileInfo } from "@bcasmart/bca-client-signature/BCADocuments";
import { $length, $ok } from "foundation-ts/commons";
import { $encodeBase64 } from "foundation-ts/data";
import { TSData } from "foundation-ts/tsdata";
import { TSError } from "foundation-ts/tserrors";
import { TSDataLike } from "foundation-ts/types";

export class BCADownloadDocumentFile implements BCADocumentFile {
    public readonly name:string ;
    public readonly type: ExtendedEnumDocumentFileType;
    public readonly mimes: string[];
    private _data: TSDataLike;
    
    constructor(fileName:string, data:TSDataLike) {
        const fileInfo = documentFileInfo(fileName) ;
        if ($ok(fileInfo)) { 
            this.type = fileInfo!.type;
            this.mimes = fileInfo!.mimes;
        } else if (fileName.endsWith('.zip')) {
            this.mimes = ['application/zip'];
            this.type = ExtendedDocumentFileTypeValues.ZIP;
        } else {
            TSError.throw(`new BCADocumentFile(): impossible to get mime type of file '${fileName}'`);
        }

        this.name = fileName;
        this._data = data;
    }

    public get fileName() { return this.name; }

    public async getSize():Promise<number> { return $length(this._data); }
    public async toUrlData():Promise<string|undefined> { return `data:${this.mimes[0]};base64,${$encodeBase64(this._data)}`; }
    public async toBase64():Promise<string|undefined> { return $encodeBase64(this._data); }
    public async toDataLike():Promise<TSDataLike|undefined> { 
        return this._data instanceof TSData ? this._data.mutableBuffer : this._data;
    }
}

const ExtendedDocumentFileTypeValues = {
    ...BCADocumentFileType,
    ZIP: 999
};
type ExtendedEnumDocumentFileType = typeof ExtendedDocumentFileTypeValues[keyof typeof ExtendedDocumentFileTypeValues];